var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.946 1.093-.42-.196-.422.196-9.525 4.425L1 5.787v7.374c0 4.584 2.764 8.717 7.002 10.466l3.141 1.297.382.158.382-.158 3.141-1.297a11.324 11.324 0 0 0 7.002-10.466V5.787l-.578-.27-9.526-4.424zM3 13.161V7.063l8.525-3.96 8.525 3.96v6.098a9.324 9.324 0 0 1-5.765 8.618l-2.76 1.14-2.76-1.14A9.324 9.324 0 0 1 3 13.16zm4.883-3.233a3.642 3.642 0 1 1 7.285 0v.419c.894.07 1.598.819 1.598 1.732v5.284c0 .96-.778 1.738-1.738 1.738H7.9c-.96 0-1.738-.778-1.738-1.738V12.08c0-.954.769-1.729 1.72-1.738v-.413zm5.285.413v-.413a1.642 1.642 0 0 0-3.285 0v.413h3.285zm-5.006 2v4.76h6.603v-4.76H8.162zm4.285 2.318a.86.86 0 1 1-1.72 0 .86.86 0 0 1 1.72 0z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/privacy_policy.e2889c54698ace52b82fcbe5522e2530.svg";
export { ForwardRef as ReactComponent };